import { runDemo } from "../shared/demoRunner";
import { createViperScene } from "./scene";

runDemo({ createScene: createViperScene });
